// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scalable-text-input {
    overflow: hidden;
    resize: none;
    width: 100%;
    border: none;
    border-bottom: #9e9e9e solid 1px;
    background-color: transparent;
    border-radius: 0;
    outline: none;
    font-size: 1.8rem;
    margin: 0 0 0.7rem 0;
    padding: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    -webkit-transition: border 0.3s, -webkit-box-shadow 0.3s;
    transition: border 0.3s, -webkit-box-shadow 0.3s;
    transition: box-shadow 0.3s, border 0.3s;
    transition: box-shadow 0.3s, border 0.3s, -webkit-box-shadow 0.3s;
}

.scalable-text-input:focus {
    outline-offset: -2px;
}

textarea:focus:not([readonly]) {
    border-bottom: 1px solid #26a69a;
    -webkit-box-shadow: 0 1px 0 0 #26a69a;
    box-shadow: 0 1px 0 0 #26a69a;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/scalable-text-input/ScalableTextInput.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,UAAU;IACV,wBAAwB;IACxB,gBAAgB;IAChB,+BAA+B;IAC/B,uBAAuB;IACvB,wDAAwD;IACxD,gDAAgD;IAChD,wCAAwC;IACxC,iEAAiE;AACrE;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;IACrC,6BAA6B;AACjC","sourcesContent":[".scalable-text-input {\r\n    overflow: hidden;\r\n    resize: none;\r\n    width: 100%;\r\n    border: none;\r\n    border-bottom: #9e9e9e solid 1px;\r\n    background-color: transparent;\r\n    border-radius: 0;\r\n    outline: none;\r\n    font-size: 1.8rem;\r\n    margin: 0 0 0.7rem 0;\r\n    padding: 0;\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n    -webkit-box-sizing: content-box;\r\n    box-sizing: content-box;\r\n    -webkit-transition: border 0.3s, -webkit-box-shadow 0.3s;\r\n    transition: border 0.3s, -webkit-box-shadow 0.3s;\r\n    transition: box-shadow 0.3s, border 0.3s;\r\n    transition: box-shadow 0.3s, border 0.3s, -webkit-box-shadow 0.3s;\r\n}\r\n\r\n.scalable-text-input:focus {\r\n    outline-offset: -2px;\r\n}\r\n\r\ntextarea:focus:not([readonly]) {\r\n    border-bottom: 1px solid #26a69a;\r\n    -webkit-box-shadow: 0 1px 0 0 #26a69a;\r\n    box-shadow: 0 1px 0 0 #26a69a;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
